function isAbsolutePath (path: string) {
  return /^(?:[a-z+]+:)?\/\//i.test(path);
}
export function generateServerUrl (url: string) {
  return isAbsolutePath(url) ? url : `${useRequestURL().origin}${url}`;
}
